import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

function UserLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
  //  const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const { login } = useContext(UserContext);

    const handleLogin = async (e) => {
        e.preventDefault();
        setMessage('Logging in...');

        try {
            const endpoint = 'https://anei2fru9a.execute-api.us-east-1.amazonaws.com/Prod/UserLogin';
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                //credentials: 'include',
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();
            if (response.ok && data.token) {
                // ✅ Save JWT to localStorage
                localStorage.setItem('jwtToken', data.token);  // store token
             //   setUser(email);  // update context
                 login({ email }, data.token);

                 setMessage('Login successful');
 
                // Redirect to dashboard or another page if needed
                // Set context + localStorage
                navigate('/dashboard');
            } else {
                const error = data;
                setMessage(`Error: ${error.message || response.statusText}`);
            }
        } catch (err) {
            setMessage(`Error: ${err.message}`);
        }
    };

    return (
        <form onSubmit={handleLogin}>
            <h2>Login</h2>
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
            <button type="submit" disabled={message === 'Logging in...'}>Login</button>
            <p>{message}</p>
        </form>
    );
}

export default UserLogin;
